'use client';

import { usePathname } from 'next/navigation'
import { Translations, getLocaleFromPathname, Locale } from '../i18n'
import deTranslations from '../i18n/translations/de.json'
import enTranslations from '../i18n/translations/en.json'
import zhCNTranslations from '../i18n/translations/zh-CN.json'

// Typisierte Übersetzungen
const translations: Record<Locale, Translations> = {
  de: deTranslations as Translations,
  en: enTranslations as Translations,
  'zh-CN': zhCNTranslations as Translations
}

export function useTranslations() {
  const pathname = usePathname()
  const locale = getLocaleFromPathname(pathname)
  
  const t = <T = string>(key: string): T => {
    // Hole Übersetzung aus JSON basierend auf key
    const keys = key.split('.')
    let translation: any = translations[locale]
    
    for (const k of keys) {
      translation = translation?.[k]
      if (!translation) return key as unknown as T // Fallback auf key wenn Übersetzung nicht gefunden
    }
    
    return translation as T
  }

  return {
    t,
    locale
  }
}
